import unescapedText from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useMemo } from 'react';
import { Link } from 'quartz-routing/react-router';
import { Paths } from '../constants/paths';
import { Subscreens } from '../constants/usage';
import { useScrollToTop } from '../hooks/useScrollToTop';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AllProductsSection({
  hasSecondaryButton = false,
  productType,
  sectionIndex
}) {
  const scrollToTop = useScrollToTop();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();

  // Generate all computed values based on product type
  const {
    descriptionText,
    seeMoreHref,
    seeMoreText,
    testId,
    titleText
  } = useMemo(() => {
    switch (productType) {
      case 'APP':
        return {
          descriptionText: unescapedText('marketplaceStorefront.allAppsCard.description'),
          seeMoreHref: `/explore?eco_PRODUCT_TYPE=APP`,
          seeMoreText: unescapedText('marketplaceStorefront.sliderSection.allApps'),
          testId: 'all-apps-card',
          titleText: unescapedText('marketplaceStorefront.allAppsCard.title')
        };
      case 'AGENT':
        return {
          descriptionText: unescapedText('marketplaceStorefront.allAgentsCard.description'),
          seeMoreHref: `/explore?eco_PRODUCT_TYPE=AGENT`,
          seeMoreText: unescapedText('marketplaceStorefront.sliderSection.allAgents'),
          testId: 'all-agents-card',
          titleText: unescapedText('marketplaceStorefront.allAgentsCard.title')
        };
      case 'SOLUTIONS_PARTNER_PROFILE':
        return {
          descriptionText: unescapedText('marketplaceStorefront.allSolutionsPartnersCard.description'),
          seeMoreHref: Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS,
          seeMoreText: unescapedText('marketplaceStorefront.allSolutionsPartnersCard.seeMore'),
          testId: 'all-solutions-partners-card',
          titleText: unescapedText('marketplaceStorefront.allSolutionsPartnersCard.title')
        };
      default:
        // All Products case
        return {
          descriptionText: unescapedText('marketplaceStorefront.exploreAllCard.description'),
          seeMoreHref: '/explore',
          seeMoreText: unescapedText('marketplaceStorefront.exploreAllCard.appsAndAgents'),
          testId: 'all-products-card',
          titleText: unescapedText('marketplaceStorefront.exploreAllCard.title')
        };
    }
  }, [productType]);
  const trackSeeMoreClick = () => trackMarketplaceEvent(getMarketplaceInteractionEvent({
    action: 'see more link clicked',
    itemIndex: sectionIndex,
    subscreen: Subscreens.ALL_PRODUCTS_SECTION,
    type: productType
  }));
  const trackSeeMoreSolutionsPartnersClick = () => trackMarketplaceEvent(getMarketplaceInteractionEvent({
    action: 'see more solutions partners link clicked',
    itemIndex: sectionIndex,
    subscreen: Subscreens.ALL_PRODUCTS_SECTION,
    type: productType
  }));
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "1000",
    "data-test-id": testId,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
      padding: "800",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h3",
        typography: "heading-400",
        children: titleText
      }), /*#__PURE__*/_jsx(Text, {
        color: "text-core-subtle",
        marginBlockStart: "200",
        marginBlockEnd: "600",
        children: descriptionText
      }), /*#__PURE__*/_jsxs(Flex, {
        gap: "400",
        children: [/*#__PURE__*/_jsx(Link, {
          to: seeMoreHref,
          onClick: () => {
            scrollToTop();
            trackSeeMoreClick();
          },
          children: /*#__PURE__*/_jsx(Button, {
            use: "tertiary-extra-light",
            children: seeMoreText
          })
        }), hasSecondaryButton && /*#__PURE__*/_jsx(Link, {
          to: Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS,
          onClick: () => {
            scrollToTop();
            trackSeeMoreSolutionsPartnersClick();
          },
          children: /*#__PURE__*/_jsx(Button, {
            use: "tertiary-extra-light",
            children: unescapedText('marketplaceStorefront.exploreAllCard.solutionsPartners')
          })
        })]
      })]
    })
  });
}